import { PrelevementModel, ResponseProfileModel, UpdateProfileModel } from './profileModel'

export const convertProfile = (profile: ResponseProfileModel) => ({
    id: profile.accountid,
    email: profile.emailaddress1,
    previousEmail: profile.emailaddress1,
    phone: profile.eft_telephonemobile2,
    type: profile.type,
    ereleve: profile.eft_e_releve,
    language: profile.eft_langue_de_communication,
    hasAcceptedEmail: profile.eft_email_marketing,
    hasAcceptedSMS: profile.eft_acceptation_sms_youfirst_campus,
    hasAcceptedEmailGroup: profile.eft_accepte_email_marketing_groupe === 1,
    hasAcceptedSMSGroup: profile.eft_accepte_sms_marketing_groupe === 1,
    followEmail: profile.followemail ?? null,
    hasSigner: profile.hasSigner
})

export const convertPostProfile = (profile: UpdateProfileModel) => ({
    email: profile.email,
    oldPassword: profile.previousPassword,
    password: profile.password,
    phone: profile.phone
})

/**
 * Convertisseur pour l'envoi à la signature
 * @param prelevement
 */
export const sendToSign = (prelevement: PrelevementModel) => {
    const { propertyConcerned, personalInfo, financialInfo } = prelevement
    const adresse = {
        numero_rue: personalInfo.street,
        code_postal: personalInfo.postalCode,
        ville: personalInfo.city,
        pays: personalInfo.country
    }

    return {
        sepa: propertyConcerned.map(contract => ({
            firstname: personalInfo.firstname,
            lastname: personalInfo.lastname,
            adresse,
            bic: financialInfo.bic,
            iban: financialInfo.iban,
            bail_id: contract.id,
            loca_id: contract.interlocutor,
            bail_numero: contract.lease,
            bien_id: contract.residences && contract.residences.length > 0 ? contract.residences[0] : ''
        })),
        signataire: {
            firstname: personalInfo.firstname,
            lastname: personalInfo.lastname,
            email: personalInfo.email,
            phone: personalInfo.phone,
            rib: financialInfo.rib
        }
    }
}
